// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { LIST_CASES } from "./action";

export function canListCases(scope: Scope): boolean {
  return scope.iamActions.includes(LIST_CASES);
}
